// Package Imports
import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';

// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';
import PrivateRouteConst from 'core/common/privateRouteConstant';

// Lazy-loaded Component
const TaskDetailsConfigurationList = lazy(
  () => import('pages/taskConfiguration/TaskDetailsConfigurationList')
);
const TaskConfigurationCreateEdit = lazy(
  () => import('pages/taskConfiguration/TaskConfigurationCreateEdit')
);
const TaskConfigRoute = (
  <Route path={routeName.taskConfiguration}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.CONFIG_TASK}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <TaskDetailsConfigurationList titleKey="task_config.task_config" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create/:id/:workflowId/:frequencyId"
      element={
        <PrivateRoute name={PrivateRouteConst.CONFIG_TASK}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <TaskConfigurationCreateEdit />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default TaskConfigRoute;
